import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { pick } from 'lodash';

@Component
export default class MixinAuth extends Vue {
  get campaignQueryParams() {
    return pick(this.$route.query, ['utm_source', 'utm_medium', 'utm_campaign']);
  }
  get campaignQueryParamsToEvent() {
    return Object.entries(this.campaignQueryParams).reduce((acc, [key, value]) => {
      (acc as any)[key.split('_')[1]] = value;
      return acc;
    }, {});
  }
}
